import { RoleLabelsMap } from './types'

export const roleLabelsMap: RoleLabelsMap = {
  super_admin: {
    label: 'Super Admin',
    chipColor: 'secondary',
  },
  admin: {
    label: 'Admin',
    chipColor: 'primary',
  },
  marketing: {
    label: 'Marketing',
    chipColor: 'default',
  },
  employee: {
    label: 'Empleado',
    chipColor: 'default',
  },
  analyst: {
    label: 'Analista',
    chipColor: 'default',
  },
}
